import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/photos/landscape-blur-3200.jpg'
import _imports_1 from '@/assets/photos/landscape-blur-2400.jpg'
import _imports_2 from '@/assets/photos/landscape-blur-1600.jpg'
import _imports_3 from '@/assets/photos/landscape-blur-1200.jpg'
import _imports_4 from '@/assets/photos/landscape-blur-800.jpg'
import _imports_5 from '@/assets/onlyoneprod-logo-white.svg'
import _imports_6 from '@/assets/icons/icon-ig.svg'
import _imports_7 from '@/assets/icons/icon-fb.svg'


const _hoisted_1 = _imports_0 + ' 3200w, ' + _imports_1 + ' 2400w, ' + _imports_2 + ' 1600w, ' + _imports_3 + ' 1200w, ' + _imports_4 + ' 800w'
const _hoisted_2 = { id: "footer" }

import { trackButtonClick } from "@/helpers/analytics.helper";
import { scrollToSection } from "@/helpers/scroll.helper";




export default /*@__PURE__*/_defineComponent({
  __name: 'SectionFooter',
  props: {
    isHome: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const clickHandler = (event: Event) => {
    if (props.isHome) {
        event.preventDefault();
        event.stopPropagation();

        let target = event.target as HTMLElement;
        if(target && target.tagName !== "A") {
            target = target.parentElement as HTMLElement;
        }

        const targetName = (target as HTMLAnchorElement).href.split("#")[1];
        trackButtonClick(`home-footer-${targetName}`);
        scrollToSection(targetName);
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_2, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "background" }, [
      _createElementVNode("img", {
        src: _imports_0,
        srcset: _hoisted_1
      })
    ], -1)),
    _createElementVNode("div", { class: "content" }, [
      _createElementVNode("div", { class: "center" }, [
        _createElementVNode("div", { class: "links" }, [
          _createElementVNode("div", { class: "logo" }, [
            _createElementVNode("a", {
              href: "/#hero",
              title: "OnlyOneProd",
              onClick: clickHandler
            }, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: _imports_5,
                alt: "Only One Prod",
                class: "logo"
              }, null, -1)
            ]))])
          ]),
          _createElementVNode("nav", { class: "menu" }, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "/#services",
                  target: "_self",
                  title: "Découvrez nos services",
                  onClick: clickHandler
                }, "Nos services")
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "/#valeurs",
                  target: "_self",
                  title: "Découvrez nos valeurs",
                  onClick: clickHandler
                }, "Nos valeurs")
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "/#methodology",
                  target: "_self",
                  title: "Découvrez notre méthode",
                  onClick: clickHandler
                }, "Notre méthode")
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "/#partners",
                  target: "_self",
                  title: "Découvrez nos partenaires",
                  onClick: clickHandler
                }, "Ils nous font confiance")
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "/#contact",
                  target: "_self",
                  title: "Contactez nous",
                  onClick: clickHandler
                }, "Nous contacter")
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "/mentions-legales",
                  target: "_self",
                  title: "Mentions légales du site"
                }, "Mentions légales")
              ], -1))
            ])
          ]),
          _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"social\"><ul><li><a href=\"https://www.instagram.com/onlyoneprod/\" target=\"_blank\"><img src=\"" + _imports_6 + "\" alt=\"Instagram\"></a></li><li><a href=\"https://www.facebook.com/onlyoneprod\" target=\"_blank\"><img src=\"" + _imports_7 + "\" alt=\"Facebook\"></a></li></ul></div>", 1))
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "copyright" }, [
          _createElementVNode("p", null, "Tous droits réservés - OnlyOneProd - 2025")
        ], -1))
      ])
    ])
  ]))
}
}

})